import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getDeployment } from '@/redux/modules/config';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to track when an item card is clicked on the lot details page
 * @returns A function to track the conversion
 */
export const useTrackItemCardClickedLotDetailsPage = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ itemId }: { itemId: number }) => {
            track(TrackingEvents.Item.ItemCardClicked, {
                itemId,
                pageName: getAmplitudePageNameFromPath(pathname),
                source: 'lot_details_page',
                url: getFullUrl(deployment, pathname),
            });
        },
        [deployment, pathname]
    );
};
